import PortfolioContext from "./PortfolioContext"
import React, { useState, useEffect } from 'react';


function PortfolioProvider({children}) {

  const [darkTheme, setDarkTheme] = useState(false);

  const contextValue = {
    darkTheme,
    setDarkTheme,
  }

  useEffect(()=>{
    localStorage.setItem('theme', JSON.stringify(darkTheme));
  }, [darkTheme])

  return (
    <PortfolioContext.Provider value={ contextValue }>
      { children }
    </PortfolioContext.Provider>
  )
}

export default PortfolioProvider;